import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PublicLayout({ children, hideFooter = false }) {
  return (
    <div className="min-h-screen flex flex-col bg-brand-base">
      <Navbar />
      <main className="flex-1 page-enter">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}
